import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import { useQueryEffect } from '../useQueryEffect/index'
import { useTemplateList } from '../useTemplate/useTemplateList'
import type { QzOption } from './useQz'
import omit from 'lodash/omit'
import type { PrinterOptions } from './useQzPrint'

type PrintTemplate = {
  printerName?: string
  type?: string
  isDefault?: boolean
  margin?: number
  qzOption?: QzOption
}

export const usePrintTemplate = ({
  type,
}: {
  type: string
}): { template: PrintTemplate; printerName: string; printerOptions: PrinterOptions; qzOption: QzOption } => {
  const [template, setTemplate] = React.useState<PrintTemplate>()
  const templateList = useTemplateList({ filter: { category: 'print_template' } })

  useQueryEffect(() => {
    if (!isEmpty(templateList.list)) {
      for (const item of templateList.list) {
        const itemObj = jsonTryParse(item?.value)
        if (itemObj?.type === type) {
          setTemplate(itemObj)
          break
        }
      }
    }
  }, templateList)

  return {
    template,
    printerName: template?.printerName,
    printerOptions: omit(template, ['printerName', 'type', 'isDefault', 'margin']) as PrinterOptions,
    qzOption: template?.qzOption,
  }
}
